import { z } from 'zod';

/** Ticket as returned by the backend (camelCase wire, ADR-0008). */
export const supportTicketSchema = z.object({
  id: z.string(),
  ref: z.string(),
  deviceId: z.string(),
  deviceName: z.string(),
  serial: z.string(),
  title: z.string(),
  description: z.string(),
  subscriptionCategory: z.string().nullable(),
  images: z.array(z.string()),
  status: z.enum(['open', 'active', 'closed', 'invalid']),
  createdAt: z.string(),
});

/** GET open-count payload. */
export const openTicketCountSchema = z.object({ count: z.number() });

export type SupportTicketDto = z.infer<typeof supportTicketSchema>;

export const supportMessageSchema = z.object({
  id: z.string(),
  author: z.enum(['grower', 'support']),
  authorName: z.string(),
  body: z.string(),
  images: z.array(z.string()),
  imageUrls: z.array(z.string()),
  createdAt: z.string(),
});

export const supportTicketSummarySchema = z.object({
  id: z.string(),
  ref: z.string(),
  title: z.string(),
  status: z.enum(['open', 'active', 'closed', 'invalid']),
  lastMessage: z.object({ fromGrower: z.boolean(), preview: z.string() }).nullable(),
  lastMessageAt: z.string(),
  unread: z.boolean(),
});

export const supportTicketDetailSchema = z.object({
  id: z.string(),
  ref: z.string(),
  title: z.string(),
  status: z.enum(['open', 'active', 'closed', 'invalid']),
  deviceName: z.string(),
  serial: z.string(),
  agent: z.object({ name: z.string(), role: z.string() }).nullable(),
  messages: z.array(supportMessageSchema),
});
